import normalizePathname from './normalizePathname';

const isSubUrlOf = (url, maybeSubUrl) => {
  const cleanUrl = normalizePathname(url || '');
  const cleanSubUrl = normalizePathname(maybeSubUrl || '');
  return cleanUrl.indexOf(cleanSubUrl) > -1;
};

export default isSubUrlOf;
